<template>
  <div class="apply-withdraw">
    <!-- 余额 -->
    <div class="apply-balance">
      <span class="apply-balance-label">余额</span>
      <span class="apply-balance-amount">{{ balance }}</span>
      <img class="apply-balance-refresh" src="/static/newImg/index/refresh01.png" @click="refreshBalance" />
    </div>

    <!-- 钱包类型 -->
    <div class="apply-wallet-types">
      <div class="apply-wallet-tag" :class="{ active: walletType === 'no' }" @click="walletType = 'no'">
        <img src="/static/newImg/withdraw/icon_cz_no.avif" class="apply-wallet-tag-no-icon" /> 钱包
      </div>
      <div class="apply-wallet-tag" :class="{ active: walletType === 'normal' }" @click="walletType = 'normal'">正常提现</div>
      <div class="apply-wallet-tag apply-wallet-tag-recharge" :class="{ active: walletType === 'recharge' }" @click="walletType = 'recharge'">
        <img src="/static/newImg/withdraw/icon_tx_txzcz.svg" class="apply-wallet-tag-recharge-icon" />
        <span class="apply-wallet-tag-badge">送2%</span>
        提现转充值
      </div>
      <div class="apply-wallet-tag" :class="{ active: walletType === 'third' }" @click="walletType = 'third'">三方钱包</div>
      <div class="apply-wallet-tag apply-wallet-tag-convert" :class="{ active: walletType === 'convert' }" @click="walletType = 'convert'">转为数字货币</div>
    </div>

    <!-- NO钱包内容 -->
    <template v-if="walletType === 'no'">
      <div class="apply-no-wallet">
        <div class="apply-no-wallet-row">
          <div class="apply-no-wallet-col">
            <div class="apply-no-wallet-desc">已有账号，可登录绑定</div>
            <div class="apply-no-wallet-btn apply-no-wallet-btn-outline" @click="onNoBind">立即绑定</div>
          </div>
          <div class="apply-no-wallet-col">
            <div class="apply-no-wallet-desc">首次使用？只需设置支付密码</div>
            <div class="apply-no-wallet-btn apply-no-wallet-btn-filled" @click="onNoSet">立即设置</div>
          </div>
        </div>
        <div class="apply-no-wallet-tip">
          用NO钱包：赚积分，抽大奖，最高<span class="apply-no-wallet-tip-highlight">88,888.88CNY</span>
        </div>
      </div>
    </template>

    <!-- 正常提现内容 -->
    <template v-if="walletType === 'normal'">
      <!-- 没绑定：显示添加按钮 -->
      <div class="apply-add-account" v-if="accountCount === 0" @click="$emit('goAccount')">
        <img src="/static/newImg/withdraw/img_tx_tjzh.svg" class="apply-add-account-icon" />
        <span>添加提现账户</span>
        <van-icon name="arrow" class="apply-add-account-arrow" />
      </div>

      <!-- 已绑定：只显示默认账户 -->
      <div class="apply-account-list" v-if="accountCount > 0">
        <div class="apply-account-item" v-for="item in defaultAccountList" :key="item.id" :class="{ active: selectedAccountId === item.id }" @click="selectedAccountId = item.id">
          <img class="apply-account-icon" :src="item.category_icon" v-if="item.category_icon" />
          <div class="apply-account-info">
            <div class="apply-account-name">
              {{ item.category_name || item.type_name }}
              <span class="apply-account-default-tag">默认</span>
            </div>
            <div class="apply-account-no">
              {{ item.mask_account }}
            </div>
          </div>
        </div>
        <div class="apply-account-manage" @click="$emit('goAccount')">管理</div>
      </div>

      <div class="apply-amount-section">
        <div class="apply-amount-title">提现金额</div>
        <div class="apply-amount-input-wrap">
          <span class="apply-amount-symbol">¥</span>
          <input class="apply-amount-input" v-model="amount" type="text" :placeholder="accountCount > 0 ? '请输入提现金额' : '请先添加提现账户才能提现'" />
        </div>
      </div>

      <div class="apply-amount-section" v-if="accountCount > 0">
        <div class="apply-amount-title">
          <span>验证提现密码</span>
          <van-icon class="apply-password-eye" :name="showPassword ? 'eye-o' : 'closed-eye'" size="18" color="#999" @click="showPassword = !showPassword" />
        </div>
        <div class="apply-password-wrap" @click="showKeyboard = true">
          <div class="apply-password-inputs">
            <div class="apply-password-box" v-for="i in 6" :key="i" :class="{ active: i === withdrawPassword.length + 1 }">
              <span v-if="withdrawPassword.length >= i" :class="{ dot: !showPassword }">{{ showPassword ? withdrawPassword[i - 1] : '●' }}</span>
              <span v-else-if="i === withdrawPassword.length + 1" class="cursor"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="apply-btn-row">
        <div class="apply-btn-interest">
          <span class="apply-btn-interest-badge">年利率100%</span>
          <span>赚取利息</span>
        </div>
        <div class="apply-btn-confirm" :class="{ disabled: !canWithdraw }" @click="confirmWithdraw">确定提现</div>
      </div>
    </template>

    <!-- 提现转充值内容 -->
    <template v-if="walletType === 'recharge'">
      <div class="apply-recharge-desc">
        功能说明：此操作直接将提现金额转为充值金额，并且享有充值活动奖励！
      </div>

      <div class="apply-amount-section">
        <div class="apply-amount-title">提现转充值金额</div>
        <div class="apply-amount-input-wrap">
          <span class="apply-amount-symbol">¥</span>
          <input class="apply-amount-input" v-model="rechargeAmount" type="text" placeholder="请输入提现金额" />
          <span class="apply-amount-all" @click="rechargeAmount = balance">全部</span>
        </div>
      </div>
      <div class="apply-recharge-fee">提现转充值免手续费</div>

      <!-- 存款优惠 -->
      <div class="apply-discount-section">
        <div class="apply-discount-header">
          <div class="apply-discount-title">
            <img src="/static/newImg/deposit/img_gift_hui.avif" class="apply-discount-title-icon" />
            存款优惠
          </div>
          <div class="apply-discount-timer">
            <img src="/static/newImg/deposit/img_xianshi.avif" class="apply-discount-timer-icon" />
            <div class="apply-discount-timer-left">
              <span class="apply-discount-timer-label">限时</span>
              <span class="apply-discount-timer-time">{{ countdownText }}</span>
            </div>
          </div>
        </div>
        <div class="apply-discount-list">
          <div class="apply-discount-item">
            <img src="/static/newImg/deposit/img_gift_hui.avif" class="apply-discount-item-icon" />
            <span class="apply-discount-item-text">赠送 2.00</span>
            <span class="apply-discount-item-condition">累计存款≥100</span>
          </div>
          <div class="apply-discount-item">
            <img src="/static/newImg/deposit/img_gift_hui.avif" class="apply-discount-item-icon" />
            <span class="apply-discount-item-text">赠送 18.00</span>
            <span class="apply-discount-item-condition">首次存款≥500</span>
          </div>
          <div class="apply-discount-item">
            <img src="/static/newImg/deposit/img_gift_hui.avif" class="apply-discount-item-icon" />
            <span class="apply-discount-item-text">赠送 5.00</span>
            <span class="apply-discount-item-condition">累计存款≥500</span>
          </div>
        </div>
        <div class="apply-discount-expand" @click="discountExpanded = !discountExpanded">
          展开 <van-icon :name="discountExpanded ? 'arrow-up' : 'arrow-down'" size="14" />
        </div>
      </div>

      <div class="apply-amount-section" v-if="accountCount > 0">
        <div class="apply-amount-title">
          <span>验证提现密码</span>
          <van-icon class="apply-password-eye" :name="showPassword ? 'eye-o' : 'closed-eye'" size="18" color="#999" @click="showPassword = !showPassword" />
        </div>
        <div class="apply-password-wrap" @click="showKeyboard = true">
          <div class="apply-password-inputs">
            <div class="apply-password-box" v-for="i in 6" :key="i" :class="{ active: i === withdrawPassword.length + 1 }">
              <span v-if="withdrawPassword.length >= i" :class="{ dot: !showPassword }">{{ showPassword ? withdrawPassword[i - 1] : '●' }}</span>
              <span v-else-if="i === withdrawPassword.length + 1" class="cursor"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="apply-btn-row">
        <div class="apply-btn-interest">
          <span class="apply-btn-interest-badge">年利率100%</span>
          <span>赚取利息</span>
        </div>
        <div class="apply-btn-confirm" :class="{ disabled: !canRechargeWithdraw }" @click="confirmRechargeWithdraw">确定提现</div>
      </div>
    </template>

    <!-- 三方钱包内容 -->
    <template v-if="walletType === 'third'">
      <div class="apply-add-account" @click="$emit('goAccount')">
        <img src="/static/newImg/withdraw/img_tx_tjzh.svg" class="apply-add-account-icon" />
        <span>添加提现账户</span>
        <van-icon name="arrow" class="apply-add-account-arrow" />
      </div>

      <div class="apply-amount-section">
        <div class="apply-amount-title">提现金额</div>
        <div class="apply-amount-input-wrap">
          <span class="apply-amount-symbol">¥</span>
          <input class="apply-amount-input" v-model="amount" type="text" placeholder="请先添加提现账户才能提现" />
        </div>
      </div>

      <div class="apply-btn-row">
        <div class="apply-btn-interest">
          <span class="apply-btn-interest-badge">年利率100%</span>
          <span>赚取利息</span>
        </div>
        <div class="apply-btn-confirm" :class="{ disabled: !canWithdraw }" @click="confirmWithdraw">确定提现</div>
      </div>
    </template>

    <!-- 转为数字货币内容 -->
    <template v-if="walletType === 'convert'">
      <div class="apply-add-account" @click="$emit('goAccount')">
        <img src="/static/newImg/withdraw/img_tx_tjzh.svg" class="apply-add-account-icon" />
        <span>添加提现账户</span>
        <van-icon name="arrow" class="apply-add-account-arrow" />
      </div>

      <div class="apply-amount-section">
        <div class="apply-amount-title">提现金额</div>
        <div class="apply-amount-input-wrap">
          <span class="apply-amount-symbol">¥</span>
          <input class="apply-amount-input" v-model="amount" type="text" placeholder="请先添加提现账户才能提现" />
        </div>
      </div>

      <div class="apply-btn-row">
        <div class="apply-btn-interest">
          <span class="apply-btn-interest-badge">年利率100%</span>
          <span>赚取利息</span>
        </div>
        <div class="apply-btn-confirm" :class="{ disabled: !canWithdraw }" @click="confirmWithdraw">确定提现</div>
      </div>
    </template>

    <!-- 数字键盘 -->
    <div class="password-keyboard-overlay" v-if="showKeyboard" @click.self="showKeyboard = false">
      <div class="password-keyboard">
        <div class="password-keyboard-row">
          <div class="password-key" v-for="n in [1,2,3]" :key="n" @click="onKey(n)">{{ n }}</div>
        </div>
        <div class="password-keyboard-row">
          <div class="password-key" v-for="n in [4,5,6]" :key="n" @click="onKey(n)">{{ n }}</div>
        </div>
        <div class="password-keyboard-row">
          <div class="password-key" v-for="n in [7,8,9]" :key="n" @click="onKey(n)">{{ n }}</div>
        </div>
        <div class="password-keyboard-row">
          <div class="password-key password-key-empty" @click="showKeyboard = false">
            <svg viewBox="0 0 24 24" width="22" height="22">
              <rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="#fff" stroke-width="1.5"/>
              <line x1="6" y1="8" x2="10" y2="8" stroke="#fff" stroke-width="1.5"/>
              <line x1="6" y1="12" x2="14" y2="12" stroke="#fff" stroke-width="1.5"/>
              <line x1="6" y1="16" x2="12" y2="16" stroke="#fff" stroke-width="1.5"/>
            </svg>
          </div>
          <div class="password-key" @click="onKey(0)">0</div>
          <div class="password-key" @click="onBackspace">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M22 3H7l-5 9 5 9h15V3z" fill="none" stroke="#fff" stroke-width="1.5"/>
              <line x1="14" y1="9" x2="18" y2="15" stroke="#fff" stroke-width="1.5"/>
              <line x1="18" y1="9" x2="14" y2="15" stroke="#fff" stroke-width="1.5"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyWithdraw',
  props: {
    accountCount: {
      type: Number,
      default: 0,
    },
    accountList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      balance: '0.00',
      walletType: 'normal',
      amount: '',
      rechargeAmount: '',
      withdrawPassword: '',
      showPassword: false,
      showKeyboard: false,
      selectedAccountId: null,
      discountExpanded: false,
      countdownText: '00:00:00',
      countdownTimer: null,
    };
  },
  computed: {
    passwordDisplay() {
      return this.withdrawPassword;
    },
    defaultAccountList() {
      return (this.accountList || []).filter(item => parseInt(item.is_default) === 1);
    },
    canWithdraw() {
      return this.accountCount > 0 && this.amount && parseFloat(this.amount) > 0 && this.withdrawPassword.length === 6;
    },
    canRechargeWithdraw() {
      return this.accountCount > 0 && this.rechargeAmount && parseFloat(this.rechargeAmount) > 0 && this.withdrawPassword.length === 6;
    },
  },
  created() {
    this.refreshBalance();
    this.startCountdown();
    this.selectDefaultAccount();
  },
  watch: {
    accountList: {
      handler() {
        this.selectDefaultAccount();
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    selectDefaultAccount() {
      if (!this.accountList || this.accountList.length === 0) {
        this.selectedAccountId = null;
        return;
      }
      // 找默认账户
      const defaultAccount = this.accountList.find(a => parseInt(a.is_default) === 1);
      if (defaultAccount) {
        this.selectedAccountId = defaultAccount.id;
      } else if (this.accountList.length > 0) {
        // 没有默认，选第一个
        this.selectedAccountId = this.accountList[0].id;
      }
    },
    refreshBalance() {
      const that = this;
      this.$apiFun.post('/api/balance', {}).then((res) => {
        if (res.code === 200) {
          that.balance = res.data.balance;
          // 同时更新 localStorage
          try {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
          } catch (e) {}
        }
      }).catch(() => {
        // 如果余额接口失败，尝试从 localStorage 读取
        try {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (userInfo && userInfo.balance !== undefined) {
            that.balance = userInfo.balance;
          }
        } catch (e) {}
      });
    },
    showGlobalToast(type, msg) {
      let comp = this;
      while (comp && !comp.showTost) {
        comp = comp.$parent;
      }
      if (comp) {
        comp.showTost(type, msg);
      } else {
        const str = type ? 'success' : 'danger';
        this.$notify({ type: str, message: msg, zIndex: 999999, duration: 2500 });
      }
    },
    convertToCrypto() {
      this.$router.push('/transfer');
    },
    onNoBind() {
      this.showGlobalToast(0, 'NO钱包绑定');
    },
    onNoSet() {
      this.showGlobalToast(0, '设置支付密码');
    },
    confirmWithdraw() {
      if (!this.canWithdraw) {
        if (!this.accountCount) {
          this.showGlobalToast(0, '请先添加提现账户');
        } else if (!this.amount || parseFloat(this.amount) <= 0) {
          this.showGlobalToast(0, '请输入正确的提现金额');
        } else {
          this.showGlobalToast(0, '请输入完整的6位提现密码');
        }
        return;
      }
      // 执行提现
      const that = this;
      this.$apiFun.post('/api/withdraw', {
        amount: this.amount,
        bank: this.selectedAccountId,
        password: this.withdrawPassword,
      }).then((res) => {
        if (res.code === 200) {
          that.showGlobalToast(1, '提现申请成功');
          that.amount = '';
          that.withdrawPassword = '';
          if (that.$parent && typeof that.$parent.refreshBalance === 'function') {
            that.$parent.refreshBalance();
          }
        } else {
          that.showGlobalToast(0, res.message || res.msg || '提现失败');
        }
      }).catch((err) => {
        that.showGlobalToast(0, err.message || '提现失败');
      });
    },
    confirmRechargeWithdraw() {
      if (!this.canRechargeWithdraw) return;
      this.showGlobalToast(0, '请输入正确的提现密码');
    },
    onKey(n) {
      if (this.withdrawPassword.length < 6) {
        this.withdrawPassword += String(n);
        // 密码输入满6位，关闭数字键盘
        if (this.withdrawPassword.length === 6) {
          this.$nextTick(() => {
            this.showKeyboard = false;
          });
        }
      }
    },
    onBackspace() {
      this.withdrawPassword = this.withdrawPassword.slice(0, -1);
    },
    startCountdown() {
      const updateTimer = () => {
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        const diff = tomorrow - now;
        const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
        const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
        const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
        this.countdownText = `${h}:${m}:${s}`;
      };
      updateTimer();
      this.countdownTimer = setInterval(updateTimer, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.apply-withdraw {
  padding: 0.2rem;
}

.apply-balance {
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
  font-size: 0.3rem;
  color: #999;

  .apply-balance-label {
    margin-right: 0.1rem;
  }

  .apply-balance-amount {
    color: #ffaa09;
    font-weight: bold;
    font-size: 0.35rem;
  }

  .apply-balance-refresh {
    width: 0.5rem;
    height: 0.5rem;
    margin-left: 0.1rem;
    cursor: pointer;
  }
}

.apply-wallet-types {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.1rem;
  margin-bottom: 0.3rem;
}

.apply-wallet-tag {
  padding: .25rem .05rem;
  border: 1px solid #555;
  border-radius: .25rem;
  font-size: 0.3rem;
  color: #fff;
  cursor: pointer;
  position: relative;
  text-align: center;
  box-sizing: border-box;
  min-width: 0;

  &.active {
    border-color: #DFB372;
    color: #DFB372;
  }

  .apply-wallet-tag-no-icon {
    width: .55rem;
    margin-right: 0.05rem;
    vertical-align: middle;
  }
}

.apply-wallet-tag-recharge {
  .apply-wallet-tag-recharge-icon {
    width: 0.35rem;
    height: 0.35rem;
    vertical-align: middle;
  }

  .apply-wallet-tag-badge {
    position: absolute;
    top: -0.15rem;
    right: -0.1rem;
    background: #ea4e3d;
    color: #fff;
    font-size: 0.18rem;
    padding: 0.02rem 0.08rem;
    border-radius: 0.1rem;
  }
}

.apply-wallet-tag-convert {
  border-color: #555;
}

.apply-no-wallet {
  margin-bottom: 0.3rem;
}

.apply-no-wallet-row {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.2rem;
}

.apply-no-wallet-col {
  flex: 1;
}

.apply-no-wallet-desc {
  font-size: 0.24rem;
  color: #999;
  margin-bottom: 0.15rem;
  text-align: center;
}

.apply-no-wallet-btn {
  padding: 0.18rem 0;
  border-radius: 0.1rem;
  text-align: center;
  font-size: 0.3rem;
  cursor: pointer;
}

.apply-no-wallet-btn-outline {
  border: 1px solid #DFB372;
  color: #DFB372;
}

.apply-no-wallet-btn-filled {
  background: #DFB372;
  color: #1a1a1a;
  font-weight: bold;
}

.apply-no-wallet-tip {
  text-align: center;
  font-size: 0.26rem;
  color: #999;
}

.apply-no-wallet-tip-highlight {
  color: #ffaa09;
  font-weight: bold;
}

.apply-add-account {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.3rem;
  background: #222;
  border-radius: 0.12rem;
  margin-top: 0.2rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
  font-size: 0.35rem;
  color: #999;
  border: thin solid #666666;

  .apply-add-account-icon {
    width: 0.6rem;
    height: 0.6rem;
    margin-right: 0.15rem;
  }

  .apply-add-account-arrow {
    margin-left: auto;
    color: #666;
  }
}

.apply-account-list {
  margin-top: 0.2rem;
  margin-bottom: 0.3rem;
}

.apply-account-item {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.3rem;
  background: #222;
  border-radius: 0.12rem;
  margin-bottom: 0.15rem;
  border: 1px solid #333;
  cursor: pointer;

  &.active,
  &.apply-account-default {
    border-color: #DFB372;
  }

  .apply-account-icon {
    width: 0.6rem;
    height: 0.6rem;
    margin-right: 0.2rem;
    border-radius: 0.08rem;
  }

  .apply-account-info {
    flex: 1;
  }

  .apply-account-name {
    font-size: 0.32rem;
    color: #fff;
  }

  .apply-account-default-tag {
    display: inline-block;
    padding: 0.02rem 0.1rem;
    margin-left: 0.1rem;
    font-size: 0.22rem;
    color: #fff;
    background: #DFB372;
    border-radius: 0.04rem;
    vertical-align: middle;
  }

  .apply-account-no {
    font-size: 0.28rem;
    color: #999;
    margin-top: 0.05rem;
  }

  .apply-account-chip {
    display: inline-block;
    padding: 0.02rem 0.12rem;
    margin-left: 0.1rem;
    background: #3a3a3a;
    border-radius: 0.04rem;
    font-size: 0.24rem;
    color: #ccc;
  }
}

.apply-account-manage {
  text-align: right;
  font-size: 0.3rem;
  color: #DFB372;
  padding: 0.1rem 0.3rem;
  cursor: pointer;
}

.apply-amount-section {
  margin-bottom: 0.3rem;
}

.apply-amount-title {
  font-size: 0.35rem;
  color: #fff;
  font-weight: 400;
  margin-bottom: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .apply-password-eye {
    cursor: pointer;
  }
}

.apply-amount-input-wrap {
  display: flex;
  align-items: center;
  background: #222;
  border-radius: 0.12rem;
  padding: 0.3rem 0.25rem;
  border: thin solid #666666;
  font-size: 0.35rem;

  .apply-amount-symbol {
    font-size: 0.35rem;
    color: #fff;
    margin-right: 0.1rem;
  }

  .apply-amount-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.3rem;
  }

  .apply-amount-all {
    color: #DFB372;
    font-size: 0.28rem;
    cursor: pointer;
  }
}

.apply-recharge-desc {
  font-size: 0.24rem;
  color: #999;
  margin-bottom: 0.3rem;
  line-height: 1.5;
}

.apply-recharge-fee {
  font-size: 0.24rem;
  color: #999;
  margin-bottom: 0.3rem;
}

.apply-discount-section {
  background: #222;
  border-radius: 0.12rem;
  padding: 0.25rem;
  margin-bottom: 0.3rem;
}

.apply-discount-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.2rem;
}

.apply-discount-title {
  display: flex;
  align-items: center;
  font-size: 0.3rem;
  color: #fff;
  font-weight: bold;

  .apply-discount-title-icon {
    width: 0.35rem;
    height: 0.35rem;
    margin-right: 0.1rem;
  }
}

.apply-discount-timer {
  display: flex;
  align-items: center;
  border: 1px solid #ff4d4f;
  border-radius: 0.08rem;
  overflow: hidden;
  position: relative;

  .apply-discount-timer-icon {
    position: absolute;
    left: -0.15rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.35rem;
    height: 0.35rem;
    z-index: 1;
  }

  .apply-discount-timer-left {
    display: flex;
    align-items: center;
    padding: 0.05rem 0.15rem 0.05rem 0.3rem;
    background: #ff4d4f;
    gap: 0.08rem;

    .apply-discount-timer-label {
      font-size: 0.22rem;
      color: #fff;
      font-weight: bold;
    }

    .apply-discount-timer-time {
      font-size: 0.24rem;
      color: #ff4d4f;
      background: #1a1a1a;
      padding: 0.02rem 0.1rem;
      border-radius: 0.04rem;
    }
  }
}

.apply-discount-list {
  .apply-discount-item {
    display: flex;
    align-items: center;
    padding: 0.15rem 0;
    border-bottom: 1px solid #333;

    &:last-child {
      border-bottom: none;
    }
  }

  .apply-discount-item-icon {
    width: 0.5rem;
    height: 0.5rem;
    margin-right: 0.15rem;
  }

  .apply-discount-item-text {
    flex: 1;
    font-size: 0.28rem;
    color: #999;
  }

  .apply-discount-item-condition {
    font-size: 0.22rem;
    color: #999;
    background: #333;
    padding: 0.04rem 0.12rem;
    border-radius: 0.06rem;
  }
}

.apply-discount-expand {
  text-align: center;
  font-size: 0.26rem;
  color: #999;
  padding-top: 0.15rem;
  cursor: pointer;
}

.apply-password-wrap {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  .apply-password-inputs {
    display: flex;
    gap: 0.1rem;
    width: 100%;
  }

  .apply-password-box {
    flex: 1;
    height: 1.1rem;
    border: 1px solid #555;
    border-radius: 0.08rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.4rem;
    color: #fff;
    background: #222;

    &.active {
      border-color: #DFB372;
    }

    .dot {
      width: 0.18rem;
      height: 0.18rem;
      background: #fff;
      border-radius: 50%;
    }

    .cursor {
      width: 2px;
      height: 0.3rem;
      background: #DFB372;
      animation: blink 1s infinite;
    }
  }
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

.password-keyboard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.password-keyboard {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 0.15rem;
  padding-bottom: 0.5rem;
  background: #1a1a1a;
}

.password-keyboard-row {
  display: flex;
  gap: 0.06rem;
  margin-bottom: 0.15rem;
}

.password-key {
  flex: 1;
  height: 1.2rem;
  background: #333;
  border-radius: 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.45rem;
  color: #fff;
  user-select: none;

  &:active {
    background: #555;
  }

  &-empty {
    background: transparent;
  }
}

.apply-btn-row {
  display: flex;
  gap: 0.2rem;
  margin-top: 0.3rem;
}

.apply-btn-interest {
  flex: 1;
  position: relative;
  padding: .3rem 0.2rem;
  border: 1px solid #DFB372;
  border-radius: 0.1rem;
  text-align: center;
  font-size: 0.3rem;
  color: #DFB372;
  cursor: pointer;

  .apply-btn-interest-badge {
    position: absolute;
    top: -0.15rem;
    left: 0;
    background: #4caf50;
    color: #fff;
    font-size: 0.18rem;
    padding: 0.02rem 0.1rem;
    border-radius: 0.06rem;
  }
}

.apply-btn-confirm {
  flex: 1;
  padding: .3rem 0.2rem;
  background: #DFB372;
  border-radius: 0.1rem;
  text-align: center;
  font-size: .35rem;
  color: #1a1a1a;
  font-weight: 400;
  cursor: pointer;

  &.disabled {
    background: #666;
    color: #1a1a1a;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/withdraw/ApplyWithdraw.vue